import * as React from "react";
import Box from "@mui/material/Box";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import TextField from "@mui/material/TextField";
import {useEffect, useState, useRef} from "react";
import {connect} from "react-redux";
import scan_img from '../scan.png'
import audio_err from '../warn.mp3'
import audio_finish from '../finish.mp3'
import {editSaveDocument, getAlLThis, getDocument, messageReset} from "../store/documents";
import axios from 'axios';
import {getAllVerifyResponse} from "../store/logIn";
import Dialog from '@mui/material/Dialog';
import {Slide, toast} from "react-toastify";

function EditDocument(props) {
    let audio = new Audio(audio_err)
    let finish = new Audio(audio_finish)
    const navigate = useNavigate()
    const params = useParams()
    const [searchParams] = useSearchParams()
    const [code, setCode] = useState('')
    const [thisOpen, setThisOpen] = useState(false)
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [queueLength, setQueueLength] = useState(0); // NEW: Track queue length for UI

    // Get track type from URL or openItem
    const trackType = React.useMemo(() => {
        let type = searchParams.get('type')
        if (!type) {
            if (searchParams.has('avia')) {
                type = 'avia'
            } else if (searchParams.has('fura')) {
                type = 'fura'
            }
        }
        return type || props.openItem?.type
    }, [searchParams, props.openItem])

    const getLocationField = (item) => {
        if (trackType === 'avia') {
            return item.place;
        } else if (trackType === 'fura') {
            return item.location || item.place;
        }
        return item.place;
    };

    const isInChina = (item) => {
        const location = getLocationField(item);
        return location === 'china';
    };

    const isInUzbekistan = (item) => {
        const location = getLocationField(item);
        return location === 'uz' || location === 'uzb';
    };

    const textFieldRef = useRef(null);
    const shouldCheckCompletion = useRef(false);
    const lastDocumentCount = useRef(0);
    const completionCheckTimeout = useRef(null);
    const initialDocumentCount = useRef(0);
    const scanCount = useRef(0);
    const initialChinaDocs = useRef([]);

    // Queue system refs
    const scanQueue = useRef([]);
    const isProcessingQueue = useRef(false);
    const lastScanTime = useRef(0);

    const handleClose = () => {
        setOpen(false);
        props.setOpen(false)
        props.setOpenItem(false)
        shouldCheckCompletion.current = false;
        scanCount.current = 0;
        setThisOpen(false);
        initialChinaDocs.current = [];

        // Clear queue
        scanQueue.current = [];
        isProcessingQueue.current = false;

        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
            completionCheckTimeout.current = null;
        }
    };

    useEffect(() => {
        if (props.open) {
            setOpen(props.open)
            const chinaDocs = props.documents.filter(item => isInChina(item));
            lastDocumentCount.current = chinaDocs.length;
            initialDocumentCount.current = chinaDocs.length;
            initialChinaDocs.current = [...chinaDocs];

            shouldCheckCompletion.current = false;
            scanCount.current = 0;

            // Reset queue
            scanQueue.current = [];
            isProcessingQueue.current = false;

            setTimeout(() => {
                if (textFieldRef.current) {
                    textFieldRef.current.focus();
                }
            }, 50);
        }
    }, [props.open, trackType])

    const checkForCompletion = () => {
        if (completionCheckTimeout.current) {
            clearTimeout(completionCheckTimeout.current);
        }

        const data = {
            "part": params['part'],
            "code": params['code'],
            "type": trackType
        }
        props.getAlLThis(data);

        completionCheckTimeout.current = setTimeout(() => {
            const currentChinaDocs = props.documents.filter(item => isInChina(item));

            if (shouldCheckCompletion.current && !isProcessingQueue.current && scanCount.current > 0) {
                const allCompleted = (currentChinaDocs.length === 0);

                if (allCompleted) {
                    finish.play();
                    toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    })
                    props.messageReset()
                    shouldCheckCompletion.current = false;

                    setTimeout(() => {
                        handleClose();
                    }, 300);
                }
            }
        }, 1000);
    };

    // NEW: Process scan queue
    const processQueue = async () => {
        if (isProcessingQueue.current || scanQueue.current.length === 0) {
            return;
        }

        isProcessingQueue.current = true;
        const trackCode = scanQueue.current.shift();

        try {
            const trackType = props.openItem['type'];
            const scanData = {
                serial_number: props.openItem['part'],
                code: props.openItem['code'],
                track_code: trackCode,
                type: trackType
            };

            const response = await axios.patch(`https://fx.softmakon.uz/api/combined-tracking/scan/`, scanData);

            if (response.status === 200) {
                if (response.data.already_scanned) {
                    // Silent skip for already scanned - don't show any message
                    console.log('Already scanned, skipping:', trackCode);
                } else {
                    // Success - show toast
                    toast.success("Muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 1200,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    });

                    setThisOpen(true);
                    scanCount.current += 1;

                    // Trigger completion check
                    setTimeout(() => {
                        shouldCheckCompletion.current = true;
                        checkForCompletion();
                    }, 400);
                }
            }
        } catch (error) {
            console.error('Error scanning document:', error);

            // Get all possible error messages
            const errorData = error.response?.data;
            const errorMessage = errorData?.error || errorData?.message || errorData?.detail || '';
            const errorStatus = error.response?.status;

            // Check if this is an "already scanned" error
            // This checks for various ways the server might indicate duplication
            const isAlreadyScanned =
                // Response status codes that indicate duplication/conflict
                errorStatus === 409 || // Conflict
                errorStatus === 208 || // Already Reported
                // Error message checks (case-insensitive)
                (typeof errorMessage === 'string' && (
                    errorMessage.toLowerCase().includes('already') ||
                    errorMessage.toLowerCase().includes('allaqachon') ||
                    errorMessage.toLowerCase().includes('скан') ||
                    errorMessage.toLowerCase().includes('duplicate') ||
                    errorMessage.toLowerCase().includes('mavjud') ||
                    errorMessage.toLowerCase().includes('exists')
                )) ||
                // Check if response data has already_scanned flag
                errorData?.already_scanned === true;

            if (isAlreadyScanned) {
                // Silent skip for already scanned errors
                console.log('Already scanned (from error), skipping:', trackCode);
            } else {
                // Real error occurred - show error and close modal
                let displayMessage = "Xatolik! Trek kod to'g'ri kelmadi!";
                if (errorMessage) {
                    displayMessage = errorMessage;
                }

                audio.play();
                toast.error(displayMessage, {
                    position: "top-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    progress: undefined,
                    theme: "colored",
                    transition: Slide,
                });

                // Clear the queue on real error and close modal
                scanQueue.current = [];
                setQueueLength(0); // Update UI
                isProcessingQueue.current = false;

                setTimeout(() => {
                    handleClose();
                }, 400);
                return; // Stop processing
            }
        }

        isProcessingQueue.current = false;

        // Process next item in queue after small delay
        if (scanQueue.current.length > 0) {
            setQueueLength(scanQueue.current.length); // Update UI
            setTimeout(() => {
                processQueue();
            }, 150);
        } else {
            setQueueLength(0); // Update UI
            // Queue is empty, refocus input
            setTimeout(() => {
                if (textFieldRef.current) {
                    textFieldRef.current.focus();
                }
            }, 100);
        }
    };

    // NEW: Add to queue instead of direct scan
    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            if (code && props.openItem && !loading) {
                const now = Date.now();

                // Prevent duplicate scans within 50ms (very short window to prevent accidental double-reads)
                if (now - lastScanTime.current < 50) {
                    setCode('');
                    return;
                }

                lastScanTime.current = now;

                // Check if this EXACT code is already in queue
                const alreadyInQueue = scanQueue.current.includes(code);

                if (!alreadyInQueue) {
                    // Add new code to queue
                    scanQueue.current.push(code);
                    setQueueLength(scanQueue.current.length);
                    console.log('Added to queue:', code, 'Queue length:', scanQueue.current.length);

                    // Start processing queue
                    processQueue();
                } else {
                    // Code already in queue - this might be scanner battery issue
                    // Don't add to queue, but also don't show error
                    console.log('Code already in queue (scanner duplicate):', code);
                }

                setCode('');
            }
        }, 100)

        return () => clearTimeout(delayDebounceFn)
    }, [code, loading, props.openItem])

    useEffect(() => {
        const currentChinaDocs = props.documents.filter(item => isInChina(item));

        if (currentChinaDocs.length > 0) {
            lastDocumentCount.current = currentChinaDocs.length;
        }

        if (shouldCheckCompletion.current &&
            thisOpen &&
            !loading &&
            !isProcessingQueue.current &&
            scanCount.current > 0) {

            if (completionCheckTimeout.current) {
                clearTimeout(completionCheckTimeout.current);
            }

            completionCheckTimeout.current = setTimeout(() => {
                const latestChinaDocs = props.documents.filter(item => isInChina(item));
                const allCompleted = (latestChinaDocs.length === 0);

                if (allCompleted &&
                    shouldCheckCompletion.current &&
                    !isProcessingQueue.current) {

                    finish.play();
                    toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        progress: undefined,
                        theme: "colored",
                        transition: Slide,
                    })
                    props.messageReset()
                    shouldCheckCompletion.current = false;

                    setTimeout(() => {
                        handleClose();
                    }, 300);
                }
            }, 400);
        }
    }, [props.documents, thisOpen, loading, trackType]);

    useEffect(() => {
        const chinaDocs = props.documents.filter(item => isInChina(item));

        if (props.message === true && chinaDocs.length > 0){
            const data = {
                "part": params['part'],
                "code": params['code'],
                "type": trackType
            }
            props.getAlLThis(data)
            props.messageReset()
        } else if (props.message === true && chinaDocs.length === 0) {
            finish.play();
            toast.success("Barchasi muvaffaqiyatli saqlandi!", {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
                transition: Slide,
            })
            props.messageReset()

            setTimeout(() => {
                handleClose();
            }, 300);
        } else if (props.message === 'error') {
            audio.play()
            toast.error("Xatolik! Trek kod to'g'ri kelmadi!", {
                position: "top-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                theme: "colored",
                transition: Slide,
            })
            props.messageReset()

            // Close modal on error (like before)
            setTimeout(() => {
                handleClose();
            }, 400);
        }
    }, [props.message, props.documents, params, props.openItem, trackType])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
        return () => {
            if (completionCheckTimeout.current) {
                clearTimeout(completionCheckTimeout.current);
            }
        };
    }, []);

    return <div>
        <Dialog
            open={open}
            onClose={handleClose}
            BackdropProps={{
                onClick: handleClose
            }}
            sx={{
                '& .MuiDialog-container': {
                    alignItems: 'flex-start'
                }
            }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                }}>
                <div style={{padding:'20px 20px 30px 20px', overflow: "hidden"}}>
                    <h3 className={'page-title text-center'}>{"Iltimos Scan Qiling!"}</h3>
                    <div className={'scan-block'}>
                        <div className={"fingerprint scanning"}>
                            <img src={scan_img} alt="Scan"/>
                        </div>
                    </div>
                    <TextField
                        ref={textFieldRef}
                        onChange={(e) => setCode(e.target.value)}
                        value={code}
                        required
                        className={"inp-text"}
                        onBlur={e => e.target.focus()}
                        type={"text"}
                        autoFocus={true}
                        variant="outlined"
                        placeholder={isProcessingQueue.current ? "Saqlanmoqda..." : "Trek kodni kiriting"}
                    />
                    {queueLength > 0 && (
                        <p style={{textAlign: 'center', color: '#1976d2', marginTop: '10px', fontWeight: 'bold'}}>
                            Navbatda: {queueLength} ta
                        </p>
                    )}
                </div>
            </Box>
        </Dialog>
    </div>
}

export default connect(props => props.documents, {
    getDocument,
    getAllVerifyResponse,
    getAlLThis,
    messageReset
})(EditDocument)